const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://bajioexpress.dvgeo.app' : 'http://192.168.100.104:3066',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://bajioexpress.dvgeo.app' : 'http://192.168.100.104:3066',
    api: 'api/',
    apiSocket: 'bajioexpress::1.2',
    nameDir: 'bajioexpress',
    package: 'app.dvgeo.bajioexpress.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyBALV9YlvNdtabiitz1bg5LnVoBviEIdpw',
    appName: 'Bajío Express',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#171a23',
    colorDark: '#171a23',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.bajioexpress.passenger',
    playStoreDriverId: 'app.dvgeo.bajioexpress.driver',
    appStorePassengerId: '6747590666',
    appStoreDriverId: '6747595979',
};
export default config;
